import useSwr from "swr"
import { map, size } from 'lodash/fp'
import { fetcher } from "../../utils/consts"

const useMusicArtistSearch = term => {
  const { data, error } = useSwr(term && size(term) > 2  ? `/api/artist?name=${term}` : null, fetcher, {revalidateOnFocus: false})

  return {
    data: data ? map(artist => ({...artist, label: artist.name}), data) : []
  }
}

const useMusicArtist = (selectedArtist) => {
  const { data, error } = useSwr(selectedArtist ? `/api/collaborations?id=${selectedArtist.id}`: null, fetcher, {revalidateOnFocus: false})

  return {data}
}


export { useMusicArtistSearch, useMusicArtist }